module.exports = __webpack_public_path__ + "img/Buybox Monitor.ca119524.svg";